import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=f0ae212c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0ae212c')) {
      api.createRecord('f0ae212c', component.options)
    } else {
      api.reload('f0ae212c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=f0ae212c&", function () {
      api.rerender('f0ae212c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R4VYGmbFSwy9/JS/pricehelp.vue"
export default component.exports